import DataQueryList from './mx-data-query-list.js';
import DataSetRowIdentity from '../../../services/dataset-row-identity';
import { GroupType } from '../../../model/enumerations';
import { EventCodes } from '../../../../../App/model/event-codes';

angular.module('mx.SolutionBuilderAgent').component('mxContentWidgetViewGrid', {
	transclude: true,
	bindings: {
		parameters: '=',
		outputPreprocessors: '<',
	},
	controller: MxContentWidgetViewGridCtrl,
	controllerAs: 'vm',
	templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-content-widget-view/list/mx-content-widget-view-grid.html',
});

MxContentWidgetViewGridCtrl.$inject = [
	'$q',
	'$scope',
	'$element',
	'$injector',
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.internationalization',
	'mx.shell.SearchProviderService',
	'mx.SolutionBuilderAgent.SearchQueryService',
	'mx.shell.ContextService',
	'mx.shell.EventService',
	'mx.sb.Agent.DataQuery.Enums',
	'mx.SolutionBuilderAgent.SortingGridPreprocessor',
	'mx.SolutionBuilderAgent.PagingPreprocessor',
	'mx.SolutionBuilderAgent.SearchPreprocessor',
	'mx.SolutionBuilderAgent.StructurePreprocessor',
	'mx.SolutionBuilderAgent.QuickFilterPreprocessor',
	'mx.SolutionBuilderAgent.ColumnDefinitionPreprocessor',
	'mx.SolutionBuilderAgent.GroupingPreprocessor',
	'mx.shell.AriaService',
	'mx.SolutionBuilderAgent.SearchQueryGroup',
	'mx.SolutionBuilderAgent.GroupingPanelService',
];

MxContentWidgetViewGridCtrl.prototype = Object.create(DataQueryList.prototype);

MxContentWidgetViewGridCtrl.prototype.reload = function () {
	const self = this;
	return DataQueryList.prototype.reload.apply(self, arguments).then(function () {
		if (self.injector.get('mx.shell.SideLayout').visible) {
			self.eventService.subscribeOnce(mx.shell.EventCodes.SidePanelVisibility, function (_, visible) {
				if (!visible && self.options && typeof self.options.refreshGridCanvas === 'function') {
					setTimeout(self.options.refreshGridCanvas, 1000);
				}
			});
		}
	});
};

function MxContentWidgetViewGridCtrl(
	$q,
	$scope,
	$element,
	$injector,
	personalizationService,
	i18n,
	searchService,
	searchQueryService,
	contextService,
	eventService,
	dataQueryEnums,
	SortingGridPreprocessor,
	PagingPreprocessor,
	SearchPreprocessor,
	StructurePreprocessor,
	QuickFilterPreprocessor,
	ColumnDefinitionPreprocessor,
	GroupingPreprocessor,
	ariaService,
	SearchQueryGroup,
	groupingPanelService
) {
	const vm = this;
	let columnFiltersIsActive = false;
	const ColumnSortingEnum = dataQueryEnums.ColumnSortingEnum;
	const searchPageGridSelector = '.mx-search-page-grid';

	vm.$onInit = function () {
		ariaService.readMessage(i18n.get('solutionBuilderAgent.aria.loading'));

		vm.groupingClickHandler = groupingClickHandler;
		vm.type = mx.SolutionBuilderAgent.ListingType.grid;

		// Todo: should think how to refactor
		vm.onSortChanged = onSortChanged;
		vm.contextService = contextService;

		vm.parameters.dataQuery.addFilterChangeHandler((columns) => searchInColumns(columns));

		vm.injector = $injector;
		vm.eventService = eventService;

		vm.preInitialize($injector, $scope);
		vm.initPreprocessors([
			SortingGridPreprocessor,
			PagingPreprocessor,
			SearchPreprocessor,
			StructurePreprocessor,
			QuickFilterPreprocessor,
			ColumnDefinitionPreprocessor,
			GroupingPreprocessor,
		]);

		if (typeof vm.outputPreprocessors === 'object') {
			angular.extend(vm.outputPreprocessors, vm.preprocessorsByName);
		}

		vm.options = {
			columnDefinitionDescriptor: vm.columnDefinitionPreprocessor,
			rowHeight: vm.parameters.rowHeight || 30,
			enableGridMenu: false,
			parameters: vm.parameters,
			allowPaging: false,
			rowColoringEnabled: vm.parameters.rowColoringEnabled === true,
			useExternalPagination: vm.dataQueryExecutor.usePostBack,
			useExternalSorting: vm.dataQueryExecutor.usePostBack,
			enableFiltering: true,
			selectionChanged: vm.selectionChanged.bind(vm),
			rowIdentity: DataSetRowIdentity,
			onItemClick: vm.itemClickHandler.bind(vm),
			onRightClick: function (entity) {
				return vm.itemRightClickHandler(entity);
			},
			onRowDblClick: function (entity) {
				vm.itemDblClickHandler(entity);
			},
		};
		vm.load().then(function () {
			if (vm.parameters.quickFilters && vm.quickFilterPreprocessor.parts > 0) {
				vm.options.columns = [
					{
						AttributeValueType: 'quickfilter',
						Alignment: '1',
						Name: 'Sys-Flags',
						Width: '58px',
						Title: i18n.get('solutionBuilderAgent.common.quickFilter'),
						Labels: vm.quickFilterPreprocessor.titles,
						Parts: vm.quickFilterPreprocessor.parts,
						IsDisplay: true,
						AriaHidden: true,
					},
				].concat(vm.columns);
			} else {
				vm.options.columns = vm.columns;
			}

			ariaService.readMessage(i18n.get('solutionBuilderAgent.aria.loaded'), 2000).then(ariaService.createPoliteFocusSettingFn(searchPageGridSelector));
		});

		eventService.subscribeTo(
			mx.shell.EventCodes.SidePanelVisibility,
			function (e, visibility) {
				if (!visibility) {
					ariaService.createPoliteFocusSettingFn(searchPageGridSelector)();
				}
			},
			$scope
		);

		eventService.subscribeTo(
			mx.shell.EventCodes.NavigationItemClicked,
			(e, navItem) => {
				if (navItem.activated) {
					setTimeout(function () {
						$(searchPageGridSelector).trigger('focus');
					}, 200);
				}
			},
			$scope
		);
	};

	vm.$postLink = function () {
		const gridMenu = $element.find('.ui-grid-menu-button');

		angular.element('.mx-search-page-place-holder').empty().append(gridMenu);
	};

	$scope.$watch('vm.loading', function (value) {
		vm.pagingPreprocessor.loading = value;
	});

	$scope.$watch('vm.parameters.rowHeight', function (value) {
		vm.options.rowHeight = value;
	});

	$scope.$watch('vm.parameters.rowColoringEnabled', function () {
		vm.options.rowColoringEnabled = vm.parameters.rowColoringEnabled === true;
	});

	eventService.subscribeTo(
		mx.shell.EventCodes.Search,
		function (event, searchOptions) {
			searchOptions = searchOptions || {};

			if (searchOptions.uiToken !== vm.parameters.uiToken || searchOptions.dataQueryList !== vm) {
				return;
			}

			if (columnFiltersIsActive) {
				const conditions = searchOptions.searchForm.getGroup(GroupType.GridSearch)?.conditions;
				if (!conditions?.length) {
					resetFilters();
				}
			}
		},
		$scope
	);

	vm.onSelectAllClick = function (allSelectedState) {
		searchService.currentSearch().dataQueryList.allSelectedState = allSelectedState;
	};

	eventService.subscribeTo(mx.SolutionBuilderAgent.Events.SearchPageReloaded, _setAriaGridInfo, $scope);

	return vm;

	function getSortedColumns(columns) {
		columns = (columns || []).map(function (column) {
			return {
				name: column.field,
				sorting: column.sort.direction === 'asc' ? ColumnSortingEnum.Ascending : ColumnSortingEnum.Descending,
				priority: column.sort.priority,
			};
		});
		columns.sort(function (columnA, columnB) {
			return columnA.priority - columnB.priority;
		});
		return columns;
	}

	function resetFilters() {
		columnFiltersIsActive = false;
		//TODO: in this case search options is controlled by external search-service and not by DataQuery or Executor instance,
		// that's why private variable is used to avoid additional search run on change handler
		// Should be removed when Executor can be used instead of search-service, and search-state component can use Executor for reset search
		vm.parameters.dataQuery._previousFilter = [];
		vm.parameters.dataQuery.clearAllFilters();
	}

	async function searchInColumns(columns) {
		let searchForm;
		const currentSearch = searchService.currentSearch();
		searchForm = currentSearch.searchForm;

		let gridSearchGroup = searchForm.getGroup(GroupType.GridSearch);
		if (gridSearchGroup) {
			gridSearchGroup.conditions = [];
		} else {
			gridSearchGroup = new SearchQueryGroup();
			searchForm.addGroup(gridSearchGroup, GroupType.GridSearch);
		}

		const conditions = await Promise.all(
			columns.map(async (column) => {
				const condition = await searchQueryService.createConditionByColumn(column.Name, vm.parameters.dataQuery);
				condition.operator = column.filter.operator;
				condition.value = column.filter.value.slice();
				return condition;
			})
		);
		gridSearchGroup.conditions.push(...conditions);

		columnFiltersIsActive = columns.length > 0;

		currentSearch.searchForm = searchForm;
		currentSearch.uiToken = vm.parameters.uiToken;
		searchService.runSearch();

		eventService.dispatchEvent(EventCodes.TrackTelemetry, {
			eventName: `Filter by column(s) executed`,
			sender: vm.parameters.id,
			senderTitle: vm.parameters.name,
			contextTypeId: vm.parameters.entities.map((entity) => entity.id),
			contextTypeTitle: vm.parameters.entities.map((entity) => entity.name),
			contextId: conditions.map((condition) => ({ name: condition.property, type: condition.type, operator: condition.operatorTechnicalName })),
		});
	}

	async function groupingClickHandler(event, column) {
		if (!groupingPanelService.isActive()) {
			groupingPanelService.open(vm.groupingPreprocessor);
		}
		await vm.groupingPreprocessor.toggleColumnGrouping(column.Name);
		eventService.dispatchEvent(EventCodes.TrackTelemetry, {
			eventName: `Data grouped`,
			sender: vm.parameters.id,
			senderTitle: vm.parameters.name,
			contextTypeId: vm.parameters.entities.map((entity) => entity.id),
			contextTypeTitle: vm.parameters.entities.map((entity) => entity.name),
			contextId: vm.groupingPreprocessor.groupedColumns.map((column) => column.Name),
		});
		$scope.$evalAsync();
	}

	function onSortChanged(columns) {
		const sortColumns = getSortedColumns(columns || []);
		vm.sortingPreprocessor.setSort(sortColumns);

		if (!vm.dataQueryExecutor.usePostBack) {
			vm.sortingPreprocessor.callChanged();
		}

		eventService.dispatchEvent(EventCodes.TrackTelemetry, {
			eventName: `Data sorted`,
			sender: vm.parameters.id,
			senderTitle: vm.parameters.name,
			contextTypeId: vm.parameters.entities.map((entity) => entity.id),
			contextTypeTitle: vm.parameters.entities.map((entity) => entity.name),
			contextId: (columns || []).map((column) => ({
				name: column.field,
				sorting: column.sort.direction,
				priority: column.sort.priority,
			})),
		});
		personalizationService.savePersonalizedSorting(getSortedColumns(columns), vm.parameters.id);
	}

	function _setAriaGridInfo() {
		const i18nPrefix = 'solutionBuilderAgent.layouts.search-page.search-page-content.';
		const i18nMany = i18n.get('components.mx-datasource-paging-panel.many');
		const totalCount = vm.parameters.totalCount > -1 ? vm.parameters.totalCount : i18nMany;
		const currentPageNumber = vm.pagingPreprocessor.page || 1;
		const itemsPerPage = vm.pagingPreprocessor.pageSize;
		const pageAmount = typeof totalCount === 'number' ? Math.ceil(totalCount / itemsPerPage) : i18nMany;
		const gridInfo = i18n.getFormatted(i18nPrefix + 'ARIA-gridNItems', totalCount);
		const paginationInfo =
			(typeof pageAmount === 'number' && pageAmount > 1) || typeof pageAmount === 'string' /* if "Many" */
				? i18n.getFormatted(i18nPrefix + 'ARIA-pagination', currentPageNumber, pageAmount)
				: '';
		const switchPagesInfo = paginationInfo && currentPageNumber === 1 ? i18n.get(i18nPrefix + 'ARIA-switchPagesInfo') : '';
		$element.find('[role=grid]').attr('aria-label', `${gridInfo}. ${paginationInfo} ${switchPagesInfo}`);
	}
}
